export function validateFormatEmailInput(email: string): boolean {
  const regexp = new RegExp(
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  );
  return regexp.test(email);
}

export function validatePhoneNumberInput(phone: string): boolean {
  const regexPhone = new RegExp(/^(\+48)\d{9}/);
  return regexPhone.test(phone) && phone.length <= 12;
}

export function validatateAreaPolishPhoneCode(input: string): boolean {
  const regexAreaCode = new RegExp(/^(\+48)/);
  return regexAreaCode.test(input);
}
